import { AbstractField } from './AbstractField';
import { store } from '@store/index';

export class TextField extends AbstractField<string, string> {
    public makeUpdateParams(): string {
        return this.fieldValue;
    }

    public getPreview(): string {
        const { entry } = store;

        if (entry.selectedLang) {
            return (
                entry.translations.getExisting(entry.selectedLang).fieldList.get(this.fieldName)?.value ??
                this.fieldValue
            );
        }

        return this.fieldValue;
    }

    protected setFieldValue(value: string): void {
        this.fieldValue = value;
    }
}
